import React from "react";
import { useTranslation } from "react-i18next";
import RulesEditorToolbar, {
	RulesEditorToolbarPropsSaveState,
} from "./rules-editor-toolbar";
import * as styles from "./rules-editor-sidebar.module.scss";
import VelavuInput from "../../../elements/velavu-input";
import VelavuSwitchBlock from "../../../elements/velavu-switch-block";
import { classArr } from "../../../helper/style-helper";

export interface RulesEditorSidebarProps {
	className?: string;

	onBack?: () => void;
	saveState?: RulesEditorToolbarPropsSaveState;
	onSave?: () => void;
	saveTooltip?: string;

	ruleName: string;
	onChangeRuleName?: (name: string) => void;

	ruleDescription: string;
	onChangeRuleDescription?: (description: string) => void;

	ruleEnabled: boolean;
	onChangeRuleEnabled?: (enabled: boolean) => void;

	disabled?: boolean;
}

/**
 * The sidebar displayed on the left side of the rules editor
 */
export default function RulesEditorSidebar(props: RulesEditorSidebarProps) {
	const { t } = useTranslation();

	return (
		<div className={classArr(styles.container, props.className)}>
			<RulesEditorToolbar
				onBack={props.onBack}
				saveState={props.saveState}
				onSave={props.onSave}
				saveTooltip={props.saveTooltip}
			/>

			<div className={styles.body}>
				<VelavuInput
					titleText={t("rules.editor.rule_name")}
					fullWidth
					placeholder={t("rules.editor.name_placeholder")}
					value={props.ruleName}
					onChange={props.onChangeRuleName}
					disabled={props.disabled}
				/>

				<VelavuInput
					titleText={t("rules.editor.rule_description")}
					fullWidth
					value={props.ruleDescription}
					onChange={props.onChangeRuleDescription}
					multiline
					autoResize
					disabled={props.disabled}
				/>

				<VelavuSwitchBlock
					toggled={props.ruleEnabled}
					onChange={props.onChangeRuleEnabled}
					disabled={props.disabled}
					label={t("rules.editor.rule_enabled")}
				/>
			</div>
		</div>
	);
}
